import React from 'react';
import PropTypes from 'prop-types';

import { renderableType } from '../proptypes/prop-types';
import { buildClassNames, buildClassNameModifiers } from '../util/utils';
import './navItemGroup.scss';

const navItemGroupClassName = 'navItemGroup';

export const NavItemGroup = ({
                        children,
                        className,
                        isNavItemGroup,
                        alignment,
                        ...other
                      }) => (
  <ul
    className={buildClassNames(
      className,
      buildClassNameModifiers(navItemGroupClassName, alignment),
      navItemGroupClassName,
    )}
    {...other}
  >
    {React.Children.map(children, child => <li>{child}</li>)}
  </ul>
);

NavItemGroup.propTypes = {
  /** @ignore */
  children: renderableType,
  /** @ignore */
  className: PropTypes.string,
  /** @ignore */
  isNavItemGroup: PropTypes.bool,
  /** The alignment of the group of nav items relative to the containing nav element */
  alignment: PropTypes.oneOf(['start', 'center', 'end']),
};

NavItemGroup.defaultProps = { isNavItemGroup: true, alignment: 'start' };
